export default __webpack_public_path__ + "static/media/krc.02a471da.jpg";